module.exports = __webpack_public_path__ + "static/img/vod-bn-1.8b728be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-1.jpg
// module id = i224
// module chunks = 1